/* AMTENDENCY — "Mostrar mais" / "Mostrar menos" da galeria da PDP.

   A referência abre com a primeira linha de fotos e guarda o resto atrás de
   um botão-pílula que alterna os dois rótulos. Como o ritmo da galeria é um
   ciclo de 3 que SEMPRE começa por um par (duas meias, uma inteira, …), a
   primeira linha é sempre os dois primeiros itens — quem esconde do terceiro
   em diante é o CSS. Aqui só sobra decidir se o botão existe e alterná-lo.

   Só no desktop: no celular a galeria é um carrossel e o botão não aparece. */
(function () {
  // 768px é o ponto de virada da referência: `@media(min-width:768px)` liga o
  // corte (`:not(.show-all) … :nth-child(n+3){display:none}`) e o botão; abaixo
  // disso a galeria é carrossel e o botão é `display:none!important`.
  var MQ = window.matchMedia('(min-width: 768px)');

  function monta(caixa) {
    var antigo = caixa.querySelector('.am-galeria-mais');
    if (antigo) antigo.remove();
    caixa.removeAttribute('data-am-galeria');

    var destino = caixa.querySelector('media-gallery') || caixa;

    var itens = caixa.querySelectorAll('.product__media-item');
    // até duas fotos tudo cabe na primeira linha: não há o que esconder
    if (!MQ.matches || itens.length <= 2) return;

    caixa.setAttribute('data-am-galeria', 'fechada');

    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'am-galeria-mais';
    b.setAttribute('aria-expanded', 'false');
    var mais = caixa.dataset.amGaleriaRotulo || 'Mostrar mais';
    var menos = caixa.dataset.amGaleriaRotuloMenos || 'Mostrar menos';
    b.textContent = mais;
    b.addEventListener('click', function () {
      var fechada = caixa.getAttribute('data-am-galeria') === 'fechada';
      if (fechada) caixa.removeAttribute('data-am-galeria');
      else caixa.setAttribute('data-am-galeria', 'fechada');
      b.textContent = fechada ? menos : mais;
      b.setAttribute('aria-expanded', String(fechada));
      // ao fechar, a página fica pendurada lá embaixo: a referência traz a
      // galeria de volta para a vista (`wrapper.scrollIntoView`)
      if (!fechada) caixa.scrollIntoView({ behavior: 'smooth' });
    });
    destino.appendChild(b);
  }

  function inicia() {
    document.querySelectorAll('.template-product .product__media-wrapper').forEach(monta);
  }

  document.addEventListener('DOMContentLoaded', inicia);
  if (document.readyState !== 'loading') inicia();
  // a troca de variante reordena os <li> da galeria (product-info.js)
  document.addEventListener('shopify:section:load', inicia);
  // cruzar os 768px troca desktop↔carrossel: o botão precisa nascer ou sumir
  MQ.addEventListener('change', inicia);
})();
